<template>
  <a-card>
    <div class="ant-descriptions-title">
      List app
    </div>
    <a-list
      item-layout="horizontal"
      :loading="loadingList"
      :data-source="getAllAppInPlatforms"
    >
      <a-list-item slot="renderItem" slot-scope="item">
        <span v-if="item.openNewTab" slot="actions">
          <a-icon type="check" /> Open new tab
        </span>
        <a-button
          type="link"
          slot="actions"
          icon="edit"
          @click="
            () => {
              visibleEdit = true;
              idAppConfig = item.id;
            }
          "
        >
          Edit
        </a-button>
        <a-popconfirm
          slot="actions"
          :title="'Copy ' + item.name"
          ok-text="Copy"
          cancel-text="Close"
          @confirm="cloneAppInPlatform(item)"
          placement="topLeft"
        >
          <a-button type="link" icon="block">
            Copy
          </a-button>
        </a-popconfirm>

        <a-list-item-meta>
          <a slot="title">
            <img
              :src="item.iconUrl"
              width="64"
              height="64"
              alt="icon"
              style="padding: 10px;"
            />
            {{ item.name }}
          </a>
          <div slot="description">
            {{ item.url }}
          </div>
        </a-list-item-meta>
      </a-list-item>
      <div slot="header" style="text-align: right;">
        <a-button
          type="link"
          slot="title"
          @click="
            () => {
              visible = true;
            }
          "
        >
          <a-icon type="plus" /> Add New
        </a-button>
      </div>
    </a-list>
    <a-drawer
      v-if="visible"
      title="Add New App"
      placement="right"
      :visible="visible"
      @close="() => (visible = false)"
      :width="550"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <AddListApp
        :close="() => (visible = false)"
        :refreshAfterCreated="refreshAfterCreated"
      />
    </a-drawer>
    <a-drawer
      v-if="visibleEdit"
      title="Edit App"
      placement="right"
      :visible="visibleEdit"
      @close="() => (visibleEdit = false)"
      :width="550"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <EditListApp
        :idAppConfig="idAppConfig"
        :refreshAfterUpdated="refreshAfterUpdated"
        :refreshAfterDeleted="refreshAfterDeleted"
        :close="() => (visibleEdit = false)"
      />
    </a-drawer>
  </a-card>
</template>
<script>
import AddListApp from "./listApp/addListApp";
import EditListApp from "./listApp/editListApp";
import query from "../constants/query";

export default {
  components: { AddListApp, EditListApp },
  data() {
    return {
      visible: false,
      visibleEdit: false,
      loadingList: false,
      loadingClone: false,
      getAllAppInPlatforms: [],
      idAppConfig: "",
    };
  },
  watch: {
    visibleEdit() {
      if (!this.visibleEdit) {
        this.idAppConfig = "";
      }
    },
  },
  methods: {
    onGetAllAppInPlatform() {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getAllAppInPlatform,
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (data?.getAllAppInPlatform) {
            this.getAllAppInPlatforms = [...data.getAllAppInPlatform];
          }
          this.loadingList = false;
        })
        .catch((error) => {
          this.loadingList = false;
          console.log("Không lấy được danh sách", error);
        });
    },
    cloneAppInPlatform(item) {
      this.loadingClone = true;
      this.$apollo
        .mutate({
          mutation: query.createAppInPlatform,
          variables: {
            url: item.url,
            iconUrl: item.iconUrl,
            name: item.name + " (copy)",
            description: item.description,
            openNewTab: item.openNewTab,
            userCanAccessIds:
              item.userCanAccess?.length > 0
                ? item.userCanAccess.map((e) => e.id)
                : null,
          },
        })
        .then(({ data }) => {
          if (data?.createAppInPlatform) {
            this.refreshAfterCreated(data.createAppInPlatform);
          }
          this.loadingClone = false;
          this.$notification.success({
            message: "Success",
            description: "Copy Success!",
          });
        })
        .catch((error) => {
          this.loadingClone = false;
          this.$notification.error({
            message: "Error",
            description: "Copy Error!",
          });
          console.log("Copy Error!", error);
        });
    },
    refreshAfterCreated(appInPlatform) {
      if (this.getAllAppInPlatforms?.length >= 0) {
        this.getAllAppInPlatforms.unshift(appInPlatform);
      }
    },
    refreshAfterUpdated(appInPlatform) {
      if (this.getAllAppInPlatforms?.length > 0) {
        const index = this.getAllAppInPlatforms.findIndex(
          (e) => e.id === appInPlatform.id
        );
        if (index >= 0) {
          this.$set(this.getAllAppInPlatforms, index, {
            ...this.getAllAppInPlatforms[index],
            ...appInPlatform,
          });
        }
      }
    },
    refreshAfterDeleted(appInPlatform) {
      if (this.getAllAppInPlatforms?.length > 0) {
        const index = this.getAllAppInPlatforms.findIndex(
          (e) => e.id === appInPlatform.id
        );
        if (index >= 0) {
          this.getAllAppInPlatforms.splice(index, 1);
        }
      }
    },
  },
  created() {
    this.onGetAllAppInPlatform();
  },
};
</script>
<style lang="css" scoped></style>
